import React from 'react';
import './LiveUpdates.css';
import socketIOClient from "socket.io-client";
import SmallHeader from './SmallHeader';
import TrackIcons from './TrackIcons';
import FlipMove from 'react-flip-move';
import moment from 'moment';

// "geleden"-tekst met minuten-precisie (bv. "12 min", "1 u 5 min").
// 'now' = de race-klok (in dev de laatste read), valt terug op de wandklok.
function compactAgo(t, now) {
  if (!t) return '';
  var s = Math.floor(((now || Date.now()) - t) / 1000);
  if (s < 60) return s + ' sec';
  var m = Math.floor(s / 60);
  if (m < 60) return m + ' min';
  var h = Math.floor(m / 60), rem = m % 60;
  return rem ? (h + ' u ' + rem + ' min') : (h + ' u');
}

class SeenAtUpdates extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    var players = this.props.players.slice(0,300); // beperken, maar ruim genoeg zodat de achterblijvers (en hun 'vermoedelijk gestopt'-tags) onderaan zichtbaar blijven


    var renderedPlayers = players.map(player => {
      return (
        <div key={player.id} className={`player${player.stopReason ? ' likely-stopped' : ''}`}>
          <div className="lu-cell lu-bib">{player.bib}</div>
          <div className="lu-cell lu-wave">{player.wave}</div>
          <div className="lu-cell lu-cat">{player.category}</div>
          <div className="lu-cell lu-name">
            {player.name}
            {player.stopReason
              ? <span className="stop-mark">
                  <span className={'stop-flag kind-' + player.stopReason.kind}>vermoedelijk gestopt</span>
                  <span className="stop-why">{player.stopReason.text}</span>
                </span>
              : <span className="seen-inline">laatst gezien {compactAgo(player.lastUpdateTime, this.props.now)} geleden</span>}
          </div>
          <div className="lu-cell lu-parcours icons"><TrackIcons icons={player.trackParts} /></div>
          <div className="lu-cell lu-seen seen-cell">
            {moment(player.lastUpdateTime).format('HH:mm:ss')}
          </div>
        </div>
      );
    });

    return (
      <div className="LiveUpdates compact">
        <SmallHeader title={this.props.title} />
        <div className="scoreboard">
          <div className="scoreboardheader">
            <div className="lu-cell lu-bib">Bib</div>
            <div className="lu-cell lu-wave">Wave</div>
            <div className="lu-cell lu-cat">Cat.</div>
            <div className="lu-cell lu-name">Naam</div>
            <div className="lu-cell lu-parcours">Parcours</div>
            <div className="lu-cell lu-seen">Gezien</div>
          </div>
          <FlipMove>
            { renderedPlayers }
          </FlipMove>
        </div>
      </div>
    );
  }
}

export default SeenAtUpdates;
